import {
  NumberField,
  BooleanField,
  SelectField,
  StringField,
  ConstantField,
} from './BasicField';
import { StaticArrayField } from './StaticArrayField';
import { ArrayField } from './ArrayField';
import { ObjectField } from './ObjectField';

export const FieldComponents = {
  number: NumberField,
  boolean: BooleanField,
  select: SelectField,
  staticArray: StaticArrayField,
  array: ArrayField,
  text: StringField,
  object: ObjectField,
  constant: ConstantField,
};
